import { baseStyles } from './base.js';
import { changelogStyles } from './changelog.js';
import { componentsStyles } from './components.js';
import { designTokens } from './design-tokens.js';
import { feedbackStyles } from './feedback.js';
import { fontStyles } from './fonts.js';
import { liveChatStyles } from './liveChat.js';
import { surveyStyles } from './survey.js';

export const CSS_STYLES =
	designTokens +
	fontStyles +
	baseStyles +
	componentsStyles +
	feedbackStyles +
	changelogStyles +
	surveyStyles +
	liveChatStyles;

export {
	baseStyles,
	changelogStyles,
	componentsStyles,
	designTokens,
	feedbackStyles,
	fontStyles,
	liveChatStyles,
	surveyStyles,
};
